export default __webpack_public_path__ + "static/media/8k.0fb7e401.gif";